import React, { useState } from "react";
import Golang1 from "./assets/golang-1.png";
import "./App.css";
import ForgeLockPage from "./forgelock";
import SatulliaPage from "./satullia";
import HafezPage from "./components/HafezPage";
import BlackjackPage from "./components/BlackjackPage";
import KpopbdayPhonePage from "./components/KpopbdayPhonePage";
import FirstCode from "./components/FirstCode";
import styled from "styled-components";

const ProjectCard = ({
  title,
  description,
  image,
  date,
  tags_front,
  tags_back,
  live_link,
  code_link,
  client_link,
  demo_link,
  medium_link,
  chrome_extension_link,
  firefox_extension_link,
  favicon,
}) => {
  var hasFrontEnd = false;
  if (tags_front != null) {
    hasFrontEnd = true;
  }

  const handleCardClick = (e) => {
    // Don't trigger if clicking on buttons
    if (e.target.closest("button, a")) {
      return;
    }

    // Priority: live_link > demo_link > medium_link > code_link
    if (live_link) {
      window.open(live_link, "_blank");
    } else if (demo_link) {
      window.open(demo_link, "_blank");
    } else if (medium_link) {
      window.open(medium_link, "_blank");
    } else if (code_link) {
      window.open(code_link, "_blank");
    }
  };

  const getFaviconUrl = () => {
    if (favicon) return favicon;

    const primaryLink =
      live_link ||
      demo_link ||
      medium_link ||
      code_link ||
      chrome_extension_link;
    if (!primaryLink) return null;

    try {
      const url = new URL(primaryLink);
      return `${url.origin}/favicon.png`;
    } catch (e) {
      return null;
    }
  };

  const faviconUrl = getFaviconUrl();

  const techIcons = {
    Flutter: "/skillicons/flutter.svg",
    React: "/skillicons/react.svg",
    Go: "/skillicons/go.svg",
    Golang: "/skillicons/go.svg",
    JavaScript: "/skillicons/js.svg",
    JS: "/skillicons/js.svg",
    TypeScript: "/skillicons/ts.svg",
    TS: "/skillicons/ts.svg",
    Python: "/skillicons/py.svg",
    "Node.js": "/skillicons/nodejs.svg",
    Java: "/skillicons/java.svg",
    SpringBoot: "/skillicons/spring.svg",
    Redis: "/skillicons/redis.svg",
    Firebase: "/skillicons/firebase.svg",
    Swift: "/skillicons/swift.svg",
    Android: "/skillicons/androidstudio.svg",
    CSS: "/skillicons/css.svg",
    "Material-UI": "/skillicons/mui.svg",
    Tailwind: "/skillicons/tailwind.svg",
    PostgreSQL: "/skillicons/postgres.svg",
    MongoDB: "/skillicons/mongodb.svg",
    Docker: "/skillicons/docker.svg",
    Vite: "/skillicons/vite.svg",
    macOS: "/skillicons/apple.svg",
    iOS: "/skillicons/apple.svg",
    "Browser Extension": "/skillicons/puzzle-piece.svg",
    Lua: "/skillicons/lua.svg",
    Neovim: "/skillicons/neovim.svg",
  };

  const renderTag = (tag, index) => {
    const iconUrl = techIcons[tag];
    return (
      <div
        key={index}
        style={{
          backgroundColor: "#181818",
          color: "white",
          padding: "4px 8px",
          borderRadius: "5px",
          marginRight: "6px",
          marginBottom: "6px",
          fontSize: "13px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        {iconUrl && (
          <img
            src={iconUrl}
            alt={tag}
            style={{ width: "14px", height: "14px" }}
          />
        )}
        {tag}
      </div>
    );
  };

  return (
    <div
      className="projectCard"
      onClick={handleCardClick}
      style={{
        cursor:
          live_link || demo_link || code_link || medium_link
            ? "pointer"
            : "default",
      }}
    >
      {/* <img
        src={image}
        alt={title}
        style={{
          width: "100%",
          objectFit: "fit",
          height: "100%",
          filter: "blur(3px) brightness(0.7)",
          transition: "filter 0.3s ease",
          "@media (max-width: 768px)": {
            height: "fit-content",
            minHeight: "200px",
          },
        }}
      /> */}
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          "@media (max-width: 768px)": {
            height: "fit-content",
            minHeight: "200px",
          },
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          left: "20px",
          right: "10px",
          top: "12px",
        }}
      >
        <h3
          style={{
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {faviconUrl &&
            (faviconUrl.length <= 2 ? (
              <span
                style={{
                  fontSize: "16px",
                  width: "16px",
                  height: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {faviconUrl}
              </span>
            ) : (
              <img
                src={faviconUrl}
                alt=""
                style={{
                  width: "22px",
                  height: "22px",
                  borderRadius: "2px",
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            ))}
          {title}
        </h3>
        <p style={{ margin: 0, color: "#bebebe", fontSize: "14px" }}>
          {description}
        </p>
        {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ color: "white", fontSize: "14px" }}>{date}</div>
        </div> */}
        <div style={{ justifyContent: "wrap", paddingTop: "10px" }}>
          {hasFrontEnd ? (
            <>
              <div style={{ fontSize: "14px" }}>Front-end</div>
              <div
                style={{ display: "flex", flexWrap: "wrap", padding: "5px" }}
              >
                {tags_front.map((tag, index) => renderTag(tag, index))}
              </div>
            </>
          ) : (
            <></>
          )}
          {tags_back ? (
            <>
              <div style={{ fontSize: "14px" }}>Back-end</div>
              <div
                style={{ display: "flex", flexWrap: "wrap", padding: "5px" }}
              >
                {tags_back.map((tag, index) => renderTag(tag, index))}
              </div>
            </>
          ) : (
            <></>
          )}
        </div>

        <div
          style={{ position: "absolute", bottom: "2px", left: 0, right: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          {medium_link ? (
            <CardButtonATag href={medium_link} target="_blank">
              <CardButton>Article</CardButton>
            </CardButtonATag>
          ) : (
            <></>
          )}
          {live_link ? (
            <CardButtonATag href={live_link} target="_blank">
              <CardButton>Live</CardButton>
            </CardButtonATag>
          ) : (
            <></>
          )}
          {code_link ? (
            <CardButtonATag href={code_link} target="_blank">
              <CardButton>Code</CardButton>
            </CardButtonATag>
          ) : (
            <></>
          )}
          {client_link ? (
            <CardButtonATag href={client_link} target="_blank">
              <CardButton>Client</CardButton>
            </CardButtonATag>
          ) : (
            <></>
          )}
          {demo_link ? (
            <CardButtonATag href={demo_link} target="_blank">
              <CardButton>Demo</CardButton>
            </CardButtonATag>
          ) : (
            <></>
          )}
          {chrome_extension_link ? (
            <CardButtonATag href={chrome_extension_link} target="_blank">
              <CardButton>Chrome</CardButton>
            </CardButtonATag>
          ) : (
            <></>
          )}
          {firefox_extension_link ? (
            <CardButtonATag href={firefox_extension_link} target="_blank">
              <CardButton>Firefox</CardButton>
            </CardButtonATag>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

const Portfolio = () => {
  const [clickCount, setClickCount] = useState(0);
  const [showEasterEgg, setShowEasterEgg] = useState(false);

  const handleTitleClick = () => {
    const newCount = clickCount + 1;
    setClickCount(newCount);

    if (newCount >= 5) {
      setShowEasterEgg(true);
    }
  };

  return (
    <div className="container">
      <div>
        <h1
          className="title"
          onClick={handleTitleClick}
          style={{ cursor: "pointer" }}
          title={
            clickCount > 0 && clickCount < 5
              ? `${5 - clickCount} more clicks to reveal a secret...`
              : clickCount === 0
              ? undefined
              : "You found the secret!"
          }
        >
          Portfolio
          {clickCount > 0 && clickCount < 5
            ? ` ${Array(clickCount + 1).join(".")}`
            : ""}
        </h1>
      </div>

      {showEasterEgg && <FirstCode />}

      <div>
        <h2 className="subtitle">Open Source Projects</h2>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <ProjectCard
          title="Flaming Cherubim"
          description="A fast, modern, and high-performance V2Ray VPN client built with Flutter."
          image={Golang1}
          date="December, 2025"
          tags_front={["Flutter", "Android", "macOS", "V2Ray", "VPN"]}
          code_link="https://github.com/danial2026/v2ray_client"
          live_link="https://github.com/danial2026/v2ray_client/releases"
          favicon="https://raw.githubusercontent.com/danial2026/v2ray_client/refs/heads/main/assets/logo.png"
        />
        <ProjectCard
          title="ForgeLock"
          description="ForgeLock is a password generator webapp that allows you to create strong passwords by using custom words, dates, numbers."
          image={Golang1}
          date="February, 2025"
          tags_front={["Flutter", "webapp"]}
          live_link="https://forgelock.danials.space/"
          code_link="https://github.com/danial2026/forgelock_app"
          favicon="https://forgelock.danials.space/favicon.png"
        />
        <ProjectCard
          title="ForgeLock Extension"
          description="A browser extension version of ForgeLock - an open-source password generator webapp that allows you to create strong passwords by using custom words, dates, numbers."
          image={Golang1}
          date="February, 2025"
          tags_front={["JS", "Browser Extension"]}
          code_link="https://github.com/danial2026/forgelock_extension"
          firefox_extension_link="https://addons.mozilla.org/en-US/firefox/addon/forgelock/"
          chrome_extension_link="https://chromewebstore.google.com/detail/forgelock/lhhheoabmdjigkddkkempmdlbpodjgoo"
          favicon="https://forgelock.danials.space/favicon.png"
        />
        {/* <ProjectCard
          title="The Invader"
          description="A tactical reimagining of the classic Space Invaders genre, focusing on the psychological impact of conflict. Features dynamic evasion, specialized enemy profiles, and narrative depth."
          image={Golang1}
          date="December, 2025"
          tags_front={["Go", "Terminal", "Game", "CLI"]}
          code_link="https://github.com/danial2026/the-invader/"
        /> */}
        <ProjectCard
          title="Kaminari Extension"
          description="A browser extension that helps you easily copy tab links from your browser in various formats."
          image={Golang1}
          date="April, 2025"
          tags_front={["JS", "Browser Extension"]}
          live_link="https://danial2026.github.io/kaminari_extension/"
          chrome_extension_link="https://chromewebstore.google.com/detail/kaminari/dmbbdjlpadjgnoolmlpodepoimflnolf"
          firefox_extension_link="https://addons.mozilla.org/en-US/firefox/addon/kaminari/"
          // code_link="https://github.com/danial2026/kaminari_extension"
          favicon="https://danial2026.github.io/kaminari_extension/icons/128.png"
        />
        <ProjectCard
          title="Tokime Extension"
          description="Simple, powerful time tracking browser extension that helps you track time spent on tasks with stopwatches."
          image={Golang1}
          date="May, 2025"
          tags_front={["JS", "Browser Extension", "Time Tracking"]}
          live_link="https://danial2026.github.io/extension_tokime/"
          chrome_extension_link="https://chromewebstore.google.com/detail/tokime/icchndlhhkbnfgagkhdmkpgifbcaoail"
          firefox_extension_link="https://addons.mozilla.org/en-US/firefox/addon/tokime/"
          // code_link="https://github.com/danial2026/extension_tokime"
          favicon="https://raw.githubusercontent.com/danial2026/extension_tokime/refs/heads/main/icons/favicon.png"
        />
        {/* <ProjectCard
          title="Task Manager App"
          description="A modern Flutter app to organize your tasks efficiently with a clean UI."
          image={Golang1}
          date="April, 2025"
          tags_front={[
            "Flutter",
            "BLoC",
            "Firebase",
            "Firestore",
            "Firebase Auth",
          ]}
          demo_link="https://youtube.com/shorts/TaZNDAXS9r4?feature=share"
          code_link="https://github.com/danial2026/task_manager_app"
        /> */}
        {/* <ProjectCard
          title="iOS-Flutter Communication Prototype"
          description="A Flutter application demonstrating bi-directional communication between Flutter and native iOS code with BLoC pattern, method channels, and event channels."
          image={Golang1}
          date="March, 2025"
          tags_front={["Flutter", "iOS", "Swift", "BLoC", "Channels"]}
          demo_link="https://www.youtube.com/shorts/4Lap_HX_JbE"
          code_link="https://github.com/danial2026/ios_communication_prototype"
        /> */}
        <ProjectCard
          title="TopBeat"
          description="Discover your spotify top song and favorite artist with our music app! Connect your Spotify account, and we'll show your most-played track."
          image={Golang1}
          date="August, 2023"
          tags_front={["React", "JavaScript", "Spotify"]}
          live_link="https://topbeat.danials.space"
          code_link="https://danialdot@github.com/danialdot/TopBeat"
          favicon="🎧"
        />
        <ProjectCard
          title="Sorame"
          description="A minimalist URL shortener service built with Go and Redis."
          image={Golang1}
          date="April, 2025"
          tags_front={["Go", "Redis", "URL Shortener"]}
          live_link="https://sorame.danials.space"
          code_link="https://github.com/danial2026/sorame"
        />
        <ProjectCard
          title="API Gateway for Microservices"
          description="An API gateway built using Golang microservices, to provide a single entry point for client applications to access services."
          image={Golang1}
          date="December, 2024"
          tags_back={["Golang", "Microservices", "API Gateway"]}
          code_link="https://github.com/danial2026/golang-gateway-service"
        />
        <ProjectCard
          title="Real-Time Chat Service"
          description="A Golang microservice-based service featuring real-time chat and push notification functionality."
          image={Golang1}
          date="February, 2023"
          tags_front={["React"]}
          tags_back={["Golang", "Chat", "Microservices"]}
          code_link="https://github.com/danial2026/chat-golang-ws-graphql"
          client_link="https://github.com/danial2026/chat-react-client"
        />
      </div>

      <div style={{ paddingTop: 60 }} />

      <div>
        <h2 className="subtitle">Tools</h2>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <ProjectCard
          title="Search Query Generator"
          description="A powerful tool that helps generate optimized search queries for various search engines and platforms with advanced filtering options"
          image={Golang1}
          date="October, 2025"
          tags_front={["React", "JavaScript", "Search"]}
          live_link="https://danials.org/search"
        />
        <ProjectCard
          title="API Monitor"
          description="Real-time API monitoring dashboard that tracks endpoint health, response times, and status codes with beautiful visualizations and alerts"
          image={Golang1}
          date="October, 2025"
          tags_front={["React", "JavaScript", "Monitoring"]}
          live_link="https://danials.org/api-monitor"
        />
        <ProjectCard
          title="SSR Preview Checker"
          description="A tool to check how your URL appears on social media platforms like Twitter, LinkedIn, Telegram, and Google Search with real-time meta tag preview"
          image={Golang1}
          date="October, 2025"
          tags_front={["React", "JavaScript", "SSR"]}
          live_link="https://danials.org/ssr"
        />
        <ProjectCard
          title="nvim-general"
          description="Reference for plugins, configs, keybindings, and snippets in nvim-general with LSP, AI commits, and more."
          image={Golang1}
          tags_front={["Neovim", "Lua", "Editor Config"]}
          code_link="https://github.com/danial2026/nvim-general"
          favicon="https://api.iconify.design/simple-icons:neovim.svg?color=%2357a143"
        />
        <ProjectCard
          title="Negah"
          description="A terminal-based network scanner written in Go"
          image={Golang1}
          tags_front={["Go", "Network", "Terminal"]}
          code_link="https://github.com/danial2026/negah"
        />
      </div>

      <div style={{ paddingTop: 60 }} />

      <div>
        <h2 className="subtitle">Flutter Packages</h2>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <ProjectCard
          title="Calendar Planner View Package"
          description="A customizable daily calendar planner view with time-based events and Material 3 design"
          image={Golang1}
          date="April, 2025"
          tags_front={["Flutter", "Package", "pub.dev"]}
          code_link="https://github.com/danial2026/calendar_planner_view"
          live_link="https://pub.dev/packages/calendar_planner_view"
          demo_link="https://calendar-planner-view.pages.dev/"
        />
        <ProjectCard
          title="Flow Stepper Widget Package"
          description="A lightweight, highly-customizable Flutter stepper/indicator widget with modern design and full styling control"
          image={Golang1}
          date="May, 2025"
          tags_front={["Flutter", "Package", "pub.dev"]}
          code_link="https://github.com/danial2026/flow_stepper_widget"
          live_link="https://pub.dev/packages/flow_stepper_widget"
          demo_link="https://flow-stepper-widget.pages.dev/"
        />
        <ProjectCard
          title="Time Range Sheet Widget"
          description="A highly customizable time range picker bottom sheet widget for Flutter with tabbed interface and extensive styling options"
          image={Golang1}
          date="May, 2025"
          tags_front={["Flutter", "Package", "pub.dev"]}
          code_link="https://github.com/danial2026/time_range_sheet_widget"
          live_link="https://pub.dev/packages/time_range_sheet_widget"
          demo_link="https://time-range-sheet-widget.pages.dev/"
        />
        <ProjectCard
          title="Bank Card Widget"
          description="A customizable and reusable bank card widget for Flutter with styling options"
          image={Golang1}
          date="June, 2025"
          tags_front={["Flutter", "Package", "pub.dev"]}
          code_link="https://github.com/danial2026/bank_card_widget"
          live_link="https://pub.dev/packages/bank_card_widget"
          demo_link="https://bank-card-widget.pages.dev/"
        />
      </div>

      <div style={{ paddingTop: 60 }} />

      <div>
        <h2 className="subtitle">Articles</h2>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <ProjectCard
          title="Google Sign-in in Flutter (without Firebase)"
          description="The article provides a step-by-step guide to implementing Google Sign-In in Flutter without Firebase"
          image={Golang1}
          tags_back={["Flutter", "Google Auth", "Authentication"]}
          medium_link="https://medium.danials.space/google-sign-in-in-flutter-without-firebase-bacab8319d49"
        />
        <ProjectCard
          title="ForgeLock: A Secure, Open-Source Password Generator"
          description="ForgeLock is a password generator webapp that allows you to create strong passwords by using custom words, dates, numbers"
          image={Golang1}
          tags_back={["Flutter", "Password Generator"]}
          medium_link="https://medium.danials.space/introducing-forgelock-9320af78b017"
          code_link="https://github.com/danial2026/forgelock_app"
        />
        <ProjectCard
          title="Beginner's Guide to Building a Flutter App"
          description="A concise guide to launching your first Flutter app, covering naming, setup, icon creation, and publishing, using free tools"
          image={Golang1}
          tags_front={["Flutter", "Beginner's Guide"]}
          medium_link="https://medium.danials.space/google-sign-in-in-flutter-without-firebase-bacab8319d49"
        />
        <ProjectCard
          title="iOS-Flutter Communication Prototype"
          description="A Flutter application demonstrating bi-directional communication between Flutter and native iOS code"
          image={Golang1}
          date="March, 2025"
          tags_front={["Flutter", "iOS", "Swift", "BLoC", "Channels"]}
          medium_link="https://medium.danials.space/building-a-bi-directional-communication-layer-between-ios-and-flutter-f2b31fe8c7d1"
          code_link="https://github.com/danial2026/ios_communication_prototype"
          demo_link="https://www.youtube.com/shorts/4Lap_HX_JbE"
        />
        <ProjectCard
          title="User Authentication Microservice"
          description="A microservice that provides user authentication services"
          image={Golang1}
          tags_front={["React"]}
          tags_back={["Java", "SpringBoot", "Microservice"]}
          // live_link="https://auth.danials.space"
          medium_link="https://medium.danials.space/build-your-own-authentication-service-with-spring-boot-cacd22d72851"
          code_link="https://github.com/danial2026/auth-service-springboot"
          client_link="https://github.com/danial2026/auth-service-react"
        />
        {/* <ProjectCard
          title="Microservice-based E-commerce platform"
          description="A scalable, reliable, and secure platform for e-commerce businesses, using microservices and Golang."
          image={Golang1}
          // image={EcommercePlatform}
          date="February, 2023"
          tags_front={['Golang', 'Microservices', 'E-commerce', 'Scalability', 'Reliability', 'Security']}
          tags_back={["Golang", "Chat", "Microservices"]}
          live_link="https://chat.danials.space"
          medium_link="https://github.com/danial2026/-"
        /> */}
        {/* <ProjectCard
          title="Real-time Inventory Management System"
          description="A microservice-based system for managing inventory in real-time, using Golang to handle large amounts of data and transactions."
          image={Golang1}
          // image={InventoryManagement}
          date="February, 2023"
          tags_front={['Golang', 'Microservices', 'Inventory Management', 'Real-time', 'Data Processing']}
          tags_back={["Golang", "Chat", "Microservices"]}
          live_link="https://chat.danials.space"
          medium_link="https://github.com/danial2026/-"
        /> */}
      </div>

      <div style={{ paddingTop: 60 }} />

      <h4
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {" "}
        ✨ These are my personal Projects and Articles. For my professional work
        and skills, please refer to my{" "}
        <a href="/resume" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
          resume
        </a>{" "}
      </h4>

      <div style={{ margin: "4rem 0rem 8rem 0rem" }} />
      <ForgeLockPage />
      <div style={{ margin: "2rem 0rem 2rem 0rem" }} />

      <div style={{ margin: "4rem 0rem 8rem 0rem" }} />
      <HafezPage />
      <div style={{ margin: "4rem 0rem 4rem 0rem" }} />

      <div style={{ margin: "4rem 0rem 8rem 0rem" }} />
      <KpopbdayPhonePage />
      <div style={{ margin: "2rem 0rem 2rem 0rem" }} />

      <div style={{ margin: "4rem 0rem 8rem 0rem" }} />
      <BlackjackPage />
      <div style={{ margin: "4rem 0rem 4rem 0rem" }} />
    </div>
  );
};

const CardButton = styled.button`
  background-color: #1a1a1a;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1.5px solid rgb(183, 183, 183, 0.7);
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
  &:hover {
    background-color: rgb(45, 44, 44);
    border: 1.5px solid rgb(183, 183, 183, 1);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(222, 222, 222, 0.26);
  }
`;

const CardButtonATag = styled.a`
  text-decoration: none;
  margin-right: 10px;
`;

export default Portfolio;
